import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import { TBusyoKengenListInfoGetRes } from "./TBusyoKengen"

/**
 * 部所権限マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class BusyoKengenService
 * @extends {ConnectApi}
 */
export default class BusyoKengenService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {(param: TApiResponse<TBusyoKengenListInfoGetRes>) => any} resolve
   * @param {(param: TApiResponse<TBusyoKengenListInfoGetRes>) => any} reject
   * @memberof BusyoKengenService
   */
  getList = async (signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TBusyoKengenListInfoGetRes>> =
        await this.getInner(`/master/busyokengen`, {}, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
